angular.module("leanlaw").controller("TrustPaymentModalController", ["$scope", "close", "payment", "invoices", "alerts", "$filter", function ($scope, close, payment, invoices, alerts, $filter) {
  $scope.payment = payment;
  $scope.invoiceString = `${invoices.length} invoice${invoices.length > 1 ? 's' : ''}`;
  $scope.showAmount = payment.amount > 0;
  const max = payment.amount;
  $scope.confirm = function () {
    if (payment.amount > max) {
      return alerts.error(`The payment amount cannot exceed ${$filter('amount')(max)}`);
    }
    if (payment.amount < 0) {
      return alerts.error(`The payment amount has to be greater than zero`);
    }
    const {
      date
    } = $scope.payment;
    $scope.payment.date = new Date(date.getFullYear(), date.getMonth(), date.getDate()).toNetworkDate();
    close($scope.payment);
  };
  $scope.reject = function () {
    close(false);
  };
}]);